import SendScenario from "./SendScenario";

export default SendScenario;
